import {
  ChitChatCard,
  MessageTabData,
  MessageTabs,
  SharedMessage as SharedMessageType,
  TaskSkill,
} from 'src/types';
import { MessageContent } from '../MessageContent';
import { useEffect, useMemo } from 'react';
import { prepareExternalModelsTabContent } from 'src/utils';
import { TabPanel, Tabs } from 'src/v2/commonComponents/Tabs';
// import { renderMessageTabList } from '../../renderMessageTabList';
import {
  NINJA_AGENT_AS_EXTERNAL_MODEL_TITLE,
  NINJA_AGENT_TITLE,
} from 'src/constants';
import { useIsNinjaModel } from 'src/hooks';
import { IconName } from 'src/components/Icon';
import { ModelIcon } from 'src/types/models/ModelIcon';

interface ChatCardProps {
  message: SharedMessageType;
  onTabClick: (tabName: string) => void;
}

export const ChatCard = ({ message, onTabClick }: ChatCardProps) => {
  const { isNinjaModel } = useIsNinjaModel({ message });

  const { data } = message.payload as ChitChatCard;
  const referenced_model_summary = data?.referenced_model_summary || {};
  const { references } = referenced_model_summary || {};
  const ninja_model_output = data?.ninja_model_output || '';

  const isFileAgent = data?.skill === TaskSkill.DOCUMENT_QA;

  const tabContent = useMemo(
    () =>
      references
        ? prepareExternalModelsTabContent({
            references,
            isNinjaModel,
            modelDisplayName: message.model_display_name,
            modelIconName: message.model_icon_name as ModelIcon,
          })
        : [],
    [
      references,
      isNinjaModel,
      message.model_display_name,
      message.model_icon_name,
    ],
  );

  const tabsData: MessageTabData[] = useMemo(() => {
    const filteredTabContent = tabContent.filter(
      ({ tabName }) => tabName !== MessageTabs.SUPER_AGENT,
    );

    return [
      ...(ninja_model_output
        ? [
            {
              tabName: MessageTabs.NINJA_AGENT,
              iconName: 'ninjaOutlined' as IconName,
              tabTitle: isFileAgent
                ? NINJA_AGENT_TITLE
                : NINJA_AGENT_AS_EXTERNAL_MODEL_TITLE,
              content: ninja_model_output || '',
            },
          ]
        : []),
      ...filteredTabContent,
    ];
  }, [ninja_model_output, tabContent, isFileAgent]);

  const defaultTab = tabsData.length
    ? tabsData[0].tabName
    : MessageTabs.NINJA_AGENT;

  useEffect(() => {
    onTabClick(defaultTab);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultTab]);

  return (
    <Tabs<string> defaultActiveTab={defaultTab} onTabClick={onTabClick}>
      {/* {renderMessageTabList({ data: tabsData, isNinjaModel })} */}

      {tabsData.map(({ tabName, content, references }) => (
        <TabPanel key={tabName} tab={tabName}>
          <MessageContent
            content={content}
            references={references}
            messageSkill={data?.skill}
          />
        </TabPanel>
      ))}
    </Tabs>
  );
};
